export default __webpack_public_path__ + "static/media/visa.dceefe75.svg";